export default __webpack_public_path__ + "static/media/95.3cc0269c.jpg";